<template>
  <div id="grid-mode">
    <div class="img-switch d-md-inline-block d-none">
      <div>
        <a class="d-inline-block mb-3" @click.prevent="switchMode(false)">
          <i v-if="largeMode" class="icon-grid1" />
          <i v-else class="icon-grid1-2" />
        </a>
      </div>
      <div>
        <a class="d-inline-block mb-3" @click.prevent="switchMode(true)">
          <i v-if="!largeMode" class="icon-grid2" />
          <i v-else class="icon-grid2-2" />
        </a>
      </div>
    </div>

    <div class="d-md-none d-block text-center" style="margin-top: 30px; margin-bottom: -24px">
      <a class="d-inline-block mx-2" @click.prevent="switchMode(false)">
        <i v-if="largeMode" class="icon-grid2" />
        <i v-else class="icon-grid2-2" />
      </a>
      <a class="d-inline-block mx-2" @click.prevent="switchMode(true)">
        <i v-if="!largeMode" class="icon-grid3" />
        <i v-else class="icon-grid3-2" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridMode',
  props: ['largemode'],
  data() {
    return {
      largeMode: this.largemode,
    };
  },
  methods: {
    switchMode(mode) {
      this.largeMode = mode;
      this.$emit('changegrid', mode);
    },
  },
};
</script>

<style></style>
